module.exports = __webpack_public_path__ + "media/images/lb/494-a96882c5b4094e80a0b6cc75a584373f.svg";